import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import {Alert, Spinner} from "react-bootstrap";
import TimePicker from "react-time-picker";

class DeviceGroupScheduleForm extends Component {

    state = {
        form: {
            id: null,
            deviceGroupId: null,
            start: null,
            end: null,
            disableDay: null,
        },
        errorResponse: null
    };

    componentDidMount() {
        const { data } = this.props;
        if(data) {
            this.setState({
                form: {
                    id: data.id,
                    start: data.start,
                    end: data.end,
                    disableDay: data.disableDay,
                    deviceGroupId: data.deviceGroupId
                }
            });
        }
    }

    handleOnChangeInput = (e) => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value
            }
        });
    };

    handleOnChangeTime = (value, name) => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [name]: value
            }
        });
    };

    handleOnChangeCheckbox = (e) => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [e.target.name]: e.target.checked
            }
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const {submit} = this.props;
        submit(this.state.form, (error) => {
            this.setState({
                ...this.state,
                errorResponse: error
            })
        });
    };

    render() {
        const { t } = this.props;
        const { errorResponse } = this.state;

        return (
            <React.Fragment>
                { this.state.form.id ? (
                    <form onSubmit={ this.handleSubmit }>
                        {  errorResponse?.data.errorMessages.Name[0] !== 'invalid_range' ||
                            (<Alert variant={"danger"}>
                                {t('msg.invalid_range')}
                            </Alert>)
                        }

                        <div className="form-group">
                            <label className="col-form-label">{t('start')}</label>
                            <div>
                                <TimePicker
                                    className='form-control'
                                    onChange={(e) => this.handleOnChangeTime(e, 'start')}
                                    maxDetail='minute'
                                    value={this.state.form.start}
                                    locale="pl-PL"
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="col-form-label">{t('end')}</label>
                            <div>
                                <TimePicker
                                    className='form-control'
                                    onChange={(e) => this.handleOnChangeTime(e, 'end')}
                                    maxDetail='minute'
                                    value={this.state.form.end}
                                    locale="pl-PL"
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="col-form-label">{t('disable-day')}</label>
                            <input
                                type="checkbox"
                                className="form-check"
                                name="disableDay"
                                onChange={this.handleOnChangeCheckbox}
                                checked={this.state.form.disableDay || false}
                            />
                        </div>

                        <div className="form-group float-right">
                            <button type="submit" className="btn btn-primary">
                                <i className="fas fa-edit"> </i> {t('save-changes')}
                            </button>
                        </div>

                    </form>
                ) : (
                    <Spinner animation={"border"}>Loading ...</Spinner>
                ) }
            </React.Fragment>
        );
    }

}
export default  withNamespaces()(DeviceGroupScheduleForm);
